import type { JSX } from 'react'
import type { IDropdownProps } from '../Dropdown'
import type { IDropdownHeaderSeasonsProps } from '../DropdownHeader/Templates'

import { useClientWidth } from 'utils/hooks'
import { Dropdown } from '../Dropdown'
import { DropdownAlignment, DropdownRowGaps } from '../Dropdown.h'
import { DropdownHeaderSeasons } from '../DropdownHeader/Templates'
import { DropdownItemsGroupSeasons } from '../DropdownItemsGroup/Templates'

export interface IDropdownSeasonsProps extends IDropdownProps {
  title?: IDropdownHeaderSeasonsProps['title']
}

export const DropdownSeasons = ({
  title = '',
  rowGap = DropdownRowGaps.SIZE_20,
  children,
  ...rest
}: IDropdownSeasonsProps): JSX.Element => {
  const clientWidth = useClientWidth()
  const alignment =
    clientWidth < 1240 ? DropdownAlignment.Left : DropdownAlignment.Right
  return (
    <Dropdown rowGap={rowGap} {...rest} alignment={alignment}>
      <DropdownHeaderSeasons title={title} />
      <DropdownItemsGroupSeasons>{children}</DropdownItemsGroupSeasons>
    </Dropdown>
  )
}
